import { Navigate, Route, Routes } from "react-router-dom";

import { AdminRoute } from "@/components/AdminRoute";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { LoginPage } from "@/features/auth/LoginPage";
import { ExportPage } from "@/features/export/ExportPage";
import { MembersPage } from "@/features/members/MembersPage";
import { ProjectSettingsPage } from "@/features/projects/ProjectSettingsPage";
import { ProjectsPage } from "@/features/projects/ProjectsPage";
import { TaggingPage } from "@/features/tagging/TaggingPage";
import { TaskListPage } from "@/features/tasks/TaskListPage";
import { UsersPage } from "@/features/users/UsersPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/projects" replace />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:projectId" element={<Navigate to="tasks" replace />} />
        <Route path="/projects/:projectId/tasks" element={<TaskListPage />} />
        <Route path="/projects/:projectId/tasks/:taskId" element={<TaggingPage />} />
        <Route
          path="/projects/:projectId/members"
          element={
            <AdminRoute>
              <MembersPage />
            </AdminRoute>
          }
        />
        <Route
          path="/projects/:projectId/settings"
          element={
            <AdminRoute>
              <ProjectSettingsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/projects/:projectId/export"
          element={
            <AdminRoute>
              <ExportPage />
            </AdminRoute>
          }
        />
        <Route
          path="/users"
          element={
            <AdminRoute>
              <UsersPage />
            </AdminRoute>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
